// import axios from 'axios'
const isDev = process.env.NODE_ENV
let baseUrl = {}
switch (isDev) {
  case 'development' :
    baseUrl = {
      infoApi: 'https://rplusapi.chanel.com.cn/InfoAPIV1210942',
      Api: 'https://rplusapi.chanel.com.cn/RetailPlusAPIV1210940',
      webUrl: 'https://rplusacc.chanel.com.cn/FileService',
      deviceApi: '',
      uploadApi: 'https://rplusacc.chanel.com.cn/FileService/api/file/upload',
      CallbackUrl: 'https://rplusinfo.chanel.com.cn/login'
    }
    break
  case 'pre' :
    baseUrl = {
      infoApi: 'https://rplusapi.chanel.com.cn/InfoAPIV1210940',
      Api: 'https://rplusapi.chanel.com.cn/RetailPlusAPIV1210940',
      webUrl: 'https://rplusacc.chanel.com.cn/FileService',
      deviceApi: '',
      uploadApi: 'https://rplusacc.chanel.com.cn/FileService/api/file/upload',
      CallbackUrl: 'https://rplusinfo.chanel.com.cn/login'
    }
    break
  case 'production' :
    baseUrl = {
      infoApi: 'https://rplusapi.chanel.com.cn/InfoAPIV1210940',
      Api: 'https://rplusapi.chanel.com.cn/RetailPlusAPIV1210940',
      webUrl: 'https://rplusacc.chanel.com.cn/FileService',
      deviceApi: '',
      uploadApi: 'https://rplusacc.chanel.com.cn/FileService/api/file/upload',
      CallbackUrl: 'https://rplusinfo.chanel.com.cn/login'
    }
    break
  case 'dev' :
    baseUrl = {
      infoApi: 'https://infoapi.r-vision-group.com',
      Api: 'https://api.r-vision-group.com',
      webUrl: 'https://filefunctions-test.chinacloudsites.cn',
      deviceApi: 'https://devicecenter-int.chinacloudsites.cn',
      uploadApi: 'https://filefunctions-test.chinacloudsites.cn/api/FileUpload',
      CallbackUrl: 'https://infoweb.r-vision-group.com/login'
    }
    break
}

export default baseUrl
